import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { changePassword } from "../../api/auth";
import { Lock, Eye, EyeOff, Loader2, ShieldCheck } from "lucide-react";
import toast from "react-hot-toast";

export default function ChangePasswordPage() {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.currentPassword) return toast.error("Mevcut şifrenizi giriniz.");
    if (!formData.newPassword) return toast.error("Yeni şifrenizi giriniz.");
    if (formData.newPassword.length < 6) return toast.error("Yeni şifre en az 6 karakter olmalıdır.");
    if (formData.newPassword !== formData.confirmPassword) return toast.error("Şifreler eşleşmiyor.");
    if (formData.currentPassword === formData.newPassword) return toast.error("Yeni şifre mevcut şifreyle aynı olamaz.");

    setLoading(true);
    try {
      await changePassword(user.userId, formData.currentPassword, formData.newPassword);
      toast.success("Şifreniz başarıyla değiştirildi");
      setFormData({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      toast.error(err.response?.data || "Şifre değiştirme işlemi başarısız oldu.");
    } finally {
      setLoading(false);
    }
  };

  const PasswordField = ({ label, name, value, show, onToggle }) => (
    <div className="form-field">
      <label>{label}</label>
      <div className="input-wrapper">
        <Lock size={18} className="input-icon" />
        <input
          type={show ? "text" : "password"}
          name={name}
          value={value}
          onChange={handleChange}
          placeholder="••••••••"
          autoComplete="new-password"
        />
        <button type="button" className="input-toggle" onClick={onToggle} tabIndex={-1}>
          {show ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
    </div>
  );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Şifre Değiştir</h2>
          <p className="page-subtitle">Hesap güvenliğiniz için şifrenizi güncelleyin</p>
        </div>
      </div>

      <div className="content-card" style={{ maxWidth: 560 }}>
        <div className="card-icon-header">
          <div className="icon-circle">
            <ShieldCheck size={28} />
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <PasswordField
            label="Mevcut Şifre"
            name="currentPassword"
            value={formData.currentPassword}
            show={showCurrent}
            onToggle={() => setShowCurrent(!showCurrent)}
          />
          <PasswordField
            label="Yeni Şifre"
            name="newPassword"
            value={formData.newPassword}
            show={showNew}
            onToggle={() => setShowNew(!showNew)}
          />
          <PasswordField
            label="Yeni Şifre (Tekrar)"
            name="confirmPassword"
            value={formData.confirmPassword}
            show={showConfirm}
            onToggle={() => setShowConfirm(!showConfirm)}
          />

          {formData.newPassword && (
            <div className="password-strength">
              <div className={`strength-bar ${formData.newPassword.length >= 8 ? "strong" : formData.newPassword.length >= 6 ? "medium" : "weak"}`} />
              <span className="strength-text">
                {formData.newPassword.length >= 8 ? "Güçlü" : formData.newPassword.length >= 6 ? "Orta" : "Zayıf"}
              </span>
            </div>
          )}

          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? <><Loader2 size={18} className="spin" /> Güncelleniyor...</> : "Şifreyi Güncelle"}
          </button>
        </form>
      </div>
    </div>
  );
}
